/* Main Menu */
var $ = jQuery.noConflict();

$(function(){
    $(document).ready(function() {
        ////////////////////////////////////////////////
        // START - mobile nav toggle (made with vanilla JS " START -  mobile nav toggle JS")
		$('.navbar-toggler').on('click', function() {
			$('.navbar-bg').toggleClass('is-active');
			$('.navbar').toggleClass('is-active');
			// toggle aria expanded value
			$(this).attr('aria-expanded', function(i, attr) {
				return attr == 'true' ? 'false' : 'true'
			});
		});
        // END - mobile nav toggle
        ///////////////////////////////////////////////

        ////////////////////////////////////////////////
        // START - turn tab row into slider
        var tabSlider = $('.tab-row');
        // slick slider settings
        var tabSliderSettings = {
            variableWidth: true,
            dots: false,
            infinite: false,
            touchThreshold: 100,
            prevArrow: '<button class="slick-arrow slick-prev"><span class="visually-hidden">Previous</span><span class="ico icon-arrow-left" aria-hidden="true"></span></button>',
            nextArrow: '<button class="slick-arrow slick-next"><span class="visually-hidden">Next</span><span class="ico icon-arrow-right" aria-hidden="true"></span></button>'
        }

        // check if tab row is on page
        if (tabSlider.length > 0) {
            // work out resize function to reinit or destroy slider on load and window resize
            $(window).on('load resize', function() {
                // loop through each tab row component
                $('.tab-row').each(function() {
                    // store tab row width
                    var tabContainerWidth = $('.tab-row').width();
                    var totalTabWidth = 0;
                    
                    // loop through item just in its parent tab row
                    $(this).find('.tab-row__item').each(function() {
                        // get outer width of each tab and add them all together
                        totalTabWidth += $(this).outerWidth(true); // include margin
                    });
                    
                    // init or destroy tab row slider depending on if total tab width is greater or less than tab row
                    if (totalTabWidth < tabContainerWidth && $(this).hasClass('slick-initialized')) {
                        $(this).slick('unslick');
                        $(this).find('.tab-row__item').removeAttr("tabindex");
                    } else if (totalTabWidth > tabContainerWidth) {
                        $(this).not('.slick-initialized').slick(tabSliderSettings);
                    }
                    
                    // work out when last slide is in view avoid lots of white space on right
                    $(this).on('afterChange', function (e, slick) {
                        var lElRect = slick.$slides[slick.slideCount - 1].getBoundingClientRect();
                        var rOffset = lElRect.x + lElRect.width;
                        var wraRect = $(this).find('.slick-list', tabSlider).get(0).getBoundingClientRect();
            
                        if (rOffset < (wraRect.x + wraRect.width)) {
                            $(this).find('.slick-next').addClass('slick-disabled');
                            $(this).find('.slick-next').attr('aria-disabled', 'true');
                        } else {
                            $(this).find('.slick-next').removeClass('slick-disabled');
                            $(this).find('.slick-next').attr('aria-disabled', 'false');
                        }
                    });
                });
            });
        }

        // if used with bootstraps nav tabs make sure it still functions
		$('.nav-tabs-container').each(function() {
            // Do not disable anchors on news archive, catgeory or search as these are used for filters.
            if (!document.querySelector("body").classList.contains("blog") && !document.querySelector("body").classList.contains("archive") && !document.querySelector("body").classList.contains("search")) {
                var $navTabsContainer = $(this);
        
                $navTabsContainer.find('.tab-row__item').on('click', function (e) {
                    e.preventDefault();
                    $navTabsContainer.find('.tab-row__item').removeClass('active');
                    $(this).addClass('active');
                });
           }
		});
        // END - turn tab row into slider
        ///////////////////////////////////////////////

        ////////////////////////////////////////////////
        // START - slick slider example
        var slider = $('.slider-items');
        var slideStatus = $('.slider-page-info');

        if (slider.length > 0) {
            // set slides to same height
            slider.on('setPosition', function () {
                $(this).find('.slick-slide').height('auto');
                var slickTrack = $(this).find('.slick-track');
                var slickTrackHeight = $(slickTrack).height();
                $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
            });

            // initiate slider for home page
            slider.slick({
                autoplay: false,
                dots: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<button class="slick-arrow slick-prev mobile-slider-arrow"><span class="visually-hidden">Previous</span><span class="ico icon-arrow-left" aria-hidden="true"></span></button>',
                nextArrow: '<button class="slick-arrow slick-next mobile-slider-arrow"><span class="visually-hidden">Next</span><span class="ico icon-arrow-right" aria-hidden="true"></span></button>',
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint:992,
                        settings: {
                            slidesToShow: 1
                        }
                    },
                ]
            });
        }
        // END - slick slider example
        ///////////////////////////////////////////////

        ////////////////////////////////////////////////
        // START - ifu filter toggling behaviour
        
        // enable/disable apply and clear buttons
        var filterCheckbox = $('.archive-section input[type=checkbox]');

        filterCheckbox.on('change', function() {
            if (filterCheckbox.is(':checked')) {
                $(this).closest('.sidebar-results__left').find('a.btn-link').removeClass('disabled');
                $(this).closest('.sidebar-results__left').find('button.btn-link').prop('disabled', false);
            } else {
                $(this).closest('.sidebar-results__left').find('a.btn-link').addClass('disabled');
                $(this).closest('.sidebar-results__left').find('button.btn-link').prop('disabled', true);
            }
        })

        // check all child checkboxes when primary checked
        var primaryFilterCheckbox = $('.archive-section .filter-group-primary .field-group:first-child input[type=checkbox]');

        primaryFilterCheckbox.on('change', function() {
            $(this).closest('.field-group').siblings('.filter-group-secondary').find("input[type=checkbox]").prop('checked', this.checked);

            // enable/disable apply and clear buttons
            if (filterCheckbox.is(':checked')) {
                $(this).closest('.sidebar-results__left').find('a.btn-link').removeClass('disabled');
                $(this).closest('.sidebar-results__left').find('button.btn-link').prop('disabled', false);
            } else {
                $(this).closest('.sidebar-results__left').find('a.btn-link').addClass('disabled');
                $(this).closest('.sidebar-results__left').find('button.btn-link').prop('disabled', true);
            }
        })

        // check all child checkboxes when secondary checked
        var secondaryFilterCheckbox = $('.archive-section .filter-group-secondary .field-group:first-child input[type=checkbox]');

        secondaryFilterCheckbox.on('change', function() {
            $(this).closest('.field-group').siblings('.filter-group-tertiary').find("input[type=checkbox]").prop('checked', this.checked);

            // enable/disable apply and clear buttons
            if (filterCheckbox.is(':checked')) {
                $(this).closest('.sidebar-results__left').find('a.btn-link').removeClass('disabled');
                $(this).closest('.sidebar-results__left').find('button.btn-link').prop('disabled', false);
            } else {
                $(this).closest('.sidebar-results__left').find('a.btn-link').addClass('disabled');
                $(this).closest('.sidebar-results__left').find('button.btn-link').prop('disabled', true);
            }
        })
        // END - ifu filter toggling behaviour
        ///////////////////////////////////////////////

        ////////////////////////////////////////////////
        // START - comparison table turn cols into slider
        var comparisonTableSlider = jQuery('.table-col-slider');
        // slick slider settings
        var comparisonTableSliderSettings = {
            mobileFirst: true,
            dots: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button class="slick-arrow slick-prev"><span class="visually-hidden">Previous</span></button>',
            nextArrow: '<button class="slick-arrow slick-next"><span class="visually-hidden">Next</span></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }
            ]

        }

        if (comparisonTableSlider.length > 0) {
            // set slides to same height
            comparisonTableSlider.on('setPosition', function () {
                jQuery(this).find('.table-col-slider__item').height('auto');
                var slickTrack = jQuery(this).find('.slick-track');
                var slickTrackHeight = jQuery(slickTrack).height();
                jQuery(this).find('.table-col-slider__item').css('height', slickTrackHeight + 'px');
            });

            // work out resize function to reinit or destroy slider on load and window resize
            jQuery(window).on('load resize', function() {        
                // init slider if not already initialised
                comparisonTableSlider.not('.slick-initialized').slick(comparisonTableSliderSettings);
            });
        }
        // END - comparison table turn cols into slider
        ///////////////////////////////////////////////

        ////////////////////////////////////////////////
        // START - comparison table match cell heights
        window.addEventListener("load", updateCompTableCellHeights);
        window.addEventListener("resize", updateCompTableCellHeights);

        function updateCompTableCellHeights() {
            const compTables = document.querySelectorAll('.comparison-table');

	        compTables.forEach(table => {
                const compTableCols = table.querySelectorAll('.comparison-table__col');
                if (compTableCols.length === 0) return;

                // Determine the maximum number of child elements within this table
                const compTableColsMaxChildren = Math.max(...Array.from(compTableCols).map(col => col.children.length));

                // Loop through each nth-child index
                for (let i = 1; i <= compTableColsMaxChildren; i++) {
                    const compTableCells = table.querySelectorAll(`.comparison-table__col > div:nth-child(${i})`);
                    let maxHeight = 0;

                    // Reset heights to auto to calculate the natural heights
                    compTableCells.forEach(element => {
                        element.style.height = 'auto';
                    });

                    // Find the maximum height for this nth-child within this table
                    compTableCells.forEach(element => {
                        const height = element.offsetHeight;
                        if (height > maxHeight) {
                            maxHeight = height;
                        }
                    });

                    // Set all elements to the maximum height for this nth-child within this table
                    compTableCells.forEach(element => {
                        element.style.height = `${maxHeight}px`;
                    });
                }
            });
        }
        // END - comparison table match cell heights
        ///////////////////////////////////////////////

        ///////////////////////////////////////////////
        // START - Product comparison form

        // Need somwhere to store the products.
        var products

        // Triggered when the confirmation page is loaded
        $(document).on('gform_confirmation_loaded', function(event, formId){
            // Comparison form is 7.
            if ( formId == 7 ) {
                load_comparison_table();
            }
        });

        // Runs every time a page is changed in a gravity form
        $(document).on('gform_page_loaded', function(event, form_id, current_page){


            // Check its the second page of the product comparison form (form id 7)
            if ( form_id == 7 && current_page == 2 ) {

                // Get the title of the category selected on page 1 and put it into the title
                var category = $('.product-categories').find('select option:selected').text();
                $('.prod-comp-cat').find('.prod-comp-cat-title').text(category);

                // The user will pause on page 2, we can use this time to get the products for the category selected.
                var categoryId = $('.product-categories').find('select option:selected').val();

                $.ajax({
                    url: custom_vars.ajax_url, // Here goes our WordPress AJAX endpoint.
                    type: 'POST',
                    data: {
                        action: 'get_products',
                        nonce: custom_vars.ajax_nonce,
                        cat_id: categoryId,
                    },
                    success: function (response) {
                        // Parse JSON response
                        var responseData = JSON.parse(response);
                        // Check if the response was successful
                        if ( responseData.success && responseData.products ) {
                            products = responseData.products
                        }
                    },
                });

                $('.prod-comp-products').find('.gfield_checkbox .gchoice').each(function() {
                    $(this).find('input').val('')
                    $(this).find('label').text('')
                    $(this).show()
                })
            }

            // Check its the third page of the product comparison form (form id 1)
            if ( form_id == 7 && current_page == 3 ) {

                var index = 0;
                
                // Get the title of the category selected on page 1 and put it into the title
                var category = $('.product-categories').find('select option:selected').text();
                $('.prod-comp-cat').find('.prod-comp-cat-title').text(category);

                $('.prod-comp-products').find('.gfield_checkbox .gchoice').each(function() {
                    if (products[index]) {
                        $(this).find('input').val(products[index]['id'])
                        $(this).find('label').text(products[index]['name'])
                    } else {
                        $(this).hide();
                    }
                    index++;
                })

            }

        });
        // END - Product comparison form
        ///////////////////////////////////////////////
    });
});

"use strict";

////////////////////////////////////////////////
// START -  mobile nav toggle JS
var navbarToggler = document.querySelector('.navbar-toggler');
var navbarBg = document.querySelector( '.navbar-bg' );
var navBar = document.querySelector( '.navbar' );
var ariaExpanded = navbarToggler.getAttribute( 'aria-expanded' ); 

navbarToggler.addEventListener( 'click' , function() {

    navBar.classList.toggle( 'is-active' );

    if (ariaExpanded == 'true' ) {
        ariaExpanded = 'false'
    } else {
        ariaExpanded = 'true'
    }
    navbarToggler.setAttribute( 'aria-expanded' , ariaExpanded);
});
// END - mobile nav toggle JS
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - remove load class from body
$(window).on('load', function() {
    // When the page has loaded
    $('body').removeClass('page-loading');
});
// END - only show focus ring on tab not click
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - only show focus ring on tab not click
function handleFirstTab(e) {
    if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
    }
}

function handleMouseDownOnce() {
    document.body.classList.remove('user-is-tabbing');
    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);
}

window.addEventListener('keydown', handleFirstTab);
// END - only show focus ring on tab not click
///////////////////////////////////////////////


///////////////////////////////////////////////
// START - Bootstrap multi-level dropdown menus

document.addEventListener("DOMContentLoaded", function(){
    function initializeMultiLevelDropdowns() {
        if (window.innerWidth < 1200) {
            document.querySelectorAll('.dropdown-toggle').forEach(function(element){
                element.addEventListener('click', function (e) {
                    let nextEl = this.nextElementSibling;
                    if(nextEl && nextEl.classList.contains('dropdown-menu--submenu')) {    
                        // prevent opening link if link needs to open dropdown
                        e.preventDefault();
                        e.stopPropagation();
                        if(nextEl.style.display == 'block'){
                            nextEl.style.display = 'none';
                        } else {
                            nextEl.style.display = 'block';
                        }
                    }
                });
            });
        }
    }

    initializeMultiLevelDropdowns();
    window.addEventListener('resize', initializeMultiLevelDropdowns);
});

// END - Bootstrap multi-level dropdown menus
///////////////////////////////////////////////

///////////////////////////////////////////////
// Start JS for header behavior. 


// Initialize behaviors when the DOM content is loaded
document.addEventListener("DOMContentLoaded", function() {
    initializeBehaviors();
    // Add a debounced resize event listener to reinitialize behaviors on window resize
    window.addEventListener('resize', debounce(initializeBehaviors, 100));
});

// Function to initialize the behaviors
function initializeBehaviors() {
    // Remove existing scroll event listeners to prevent multiple bindings
    window.removeEventListener('scroll', headerBehavior);
    window.removeEventListener('scroll', dropdownBehavior);
    window.removeEventListener('scroll', searchBehavior);

    // Re-add the behaviors only if the window width is greater than 1200px
    if (window.innerWidth > 1200) {
        headerBehavior();
        dropdownBehavior();
        searchBehavior();
    }
}

// Debounce function to limit the rate of function execution
function debounce(func, wait) {
    let timeout;
    return function() {
        clearTimeout(timeout);
        timeout = setTimeout(func, wait);
    };
}

// Function to handle header visibility based on scroll direction
function headerBehavior() {
    var header = document.querySelector('.header'),
        body = document.querySelector('body.body-theme');

    // Exit if header or body elements are not found
    if (!header || !body) return;

    var lastScrollTop = 0,
        delta = 50; // Minimum scroll distance to trigger the toggle

    // Function to hide the header
    function hideHeader() {
        body.classList.add('header-hide');
        body.classList.remove('header-show');
        header.classList.add('header-hide');
        header.classList.remove('header-show');
    }

    // Function to show the header
    function showHeader() {
        body.classList.remove('header-hide');
        body.classList.add('header-show');
        header.classList.remove('header-hide');
        header.classList.add('header-show');
    }

    // Function to determine scroll direction and toggle header visibility
    function onScroll() {
        var nowScrollTop = window.scrollY;
        if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
            if (nowScrollTop > lastScrollTop) {
                hideHeader(); // User is scrolling down, hide the header
            } else {
                showHeader(); // User is scrolling up, show the header
            }
            lastScrollTop = nowScrollTop;
        }
    }

    // Throttle function to control the rate of scroll event handling
    var throttledScroll = throttle(onScroll, 100);

    // Throttle implementation to limit the rate of function execution
    function throttle(fn, wait) {
        var time = Date.now();
        return function() {
            if ((time + wait - Date.now()) < 0) {
                fn();
                time = Date.now();
            }
        };
    }

    // Add scroll event listener
    window.addEventListener('scroll', throttledScroll);
}

// Function to adjust the position of dropdown menus based on header visibility and window size
function dropdownBehavior() { const dropdownButtons = document.querySelectorAll('.nav-desk .dropdown-toggle');
   

    // Adjust the top position of the dropdown menu
    function adjustDropdownTop() {
        if (window.innerWidth > 1200) {
            const header = document.querySelector('.header');
            const headerBottom = document.querySelector('.header-bottom');
            if (!header || !headerBottom) return;

            // Determine header height based on its visibility
            const headerHeight = header.classList.contains('header-hide') ? headerBottom.offsetHeight : header.offsetHeight;

            document.querySelectorAll('.dropdown-menu.show').forEach(dropdownMenu => {
                if (!dropdownMenu.classList.contains('dropdown-menu--absolute') && !dropdownMenu.closest('.navbar-search')) {
                    dropdownMenu.style.top = `${headerHeight}px`;
                }
            });
        } else {
            // Reset the top style for mobile view
            document.querySelectorAll('.dropdown-menu').forEach(dropdownMenu => {
                dropdownMenu.style.top = '';
            });
        }
    }

    // Add hover event listeners to dropdown buttons
    function addHoverListeners() {
        dropdownButtons.forEach(button => {
            button.addEventListener('mouseover', function() {
                adjustDropdownTop();
            });
        });
    }

    // Use MutationObserver to detect changes in the dropdown menu visibility
    function addMutationObservers() {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.attributeName === 'class' && mutation.target.classList.contains('show')) {
                    adjustDropdownTop();
                }
            });
        });

        // Observe attribute changes on dropdown menus
        document.querySelectorAll('.dropdown-menu').forEach(dropdownMenu => {
            observer.observe(dropdownMenu, { attributes: true });
        });
    }

    // Initialize hover listeners and mutation observers
    addHoverListeners();
    addMutationObservers();

    // Add resize and scroll event listeners to adjust dropdown top position
    window.addEventListener('resize', adjustDropdownTop);
    window.addEventListener('scroll', adjustDropdownTop);
}

// Function to handle search button behavior based on header visibility and window size
function searchBehavior() {
    const openSearchButton = document.getElementById('openSearchDesk');

    // Function to scroll the window up smoothly when search is opened
    function handleSearchOpen() {
        window.scrollBy({
            top: -100,
            behavior: 'smooth'
        });
    }

    if (window.innerWidth > 1200) {
        // Add click event listener to the search button
        openSearchButton.addEventListener('click', function(event) {
            event.preventDefault();
            handleSearchOpen();
        });

        // Adjust event listeners on window resize
        window.addEventListener('resize', function() {
            if (window.innerWidth > 1200) {
                openSearchButton.addEventListener('click', function(event) {
                    event.preventDefault();
                    handleSearchOpen();
                });
            } else {
                openSearchButton.removeEventListener('click', function(event) {
                    event.preventDefault();
                    handleSearchOpen();
                });
            }
        });
    }
}

// END  JS for header behavior. 
///////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////
// START - scroll behaviour to add and remove classes on comparison table
document.addEventListener('DOMContentLoaded', () => {
	const siteHeader = document.querySelector('.header');
	const comparisonTables = document.querySelectorAll('.comparison-table');
	const siteHeaderHeight = siteHeader ? siteHeader.offsetHeight : 0;

	// Function to check visibility of elements and update classes
	function checkTableVisibility() {
		comparisonTables.forEach(table => {
			const rect = table.getBoundingClientRect();
			const tableTop = rect.top;
			const tableBottom = rect.bottom;

			// Check if the bottom of the table is above the bottom of the viewport
			const isAboveViewportBottom = tableBottom <= window.innerHeight;

			// Add 'in-view' class if the top of the table is within the viewport and remove otherwise
			if (tableTop < window.innerHeight && !isAboveViewportBottom) {
				table.classList.add('in-view');
			} else {
				table.classList.remove('in-view');
			}

			// Add 'fix-first-cell' class if the top of the table is near the header and remove otherwise
			if (tableTop <= siteHeaderHeight && tableBottom >= siteHeaderHeight) {
				table.classList.add('fix-first-cell');
			} else {
				table.classList.remove('fix-first-cell');
			}
		});
	}

	// Event listener for scroll and resize to update visibility classes
	window.addEventListener('scroll', checkTableVisibility);
	window.addEventListener('resize', checkTableVisibility);

	// Initial check on load
	checkTableVisibility();
});
// END - scroll behaviour to add and remove classes on comparison table
//////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////
// START - enable tooltips
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
// END - enable tooltips
//////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////
// START - fixes the position of hero cells in a comparison table

document.addEventListener('DOMContentLoaded', () => {
    const heroCells = document.querySelectorAll('.product-col__cell--hero'); // Select all hero cells in the comparison table
    const header = document.querySelector('.header'); // Select the header element
    const offset = -100; // Offset from top of viewport in pixels

    function checkHeroCellPosition() {
        const scrollPosition = window.scrollY; // Get the current scroll position
        const headerHeight = header ? header.offsetHeight : 0; // Get the header height or set to 0 if header is not found

        heroCells.forEach(cell => {
            const table = cell.closest('.comparison-table'); // Find the closest comparison table ancestor
            const tableRect = table.getBoundingClientRect(); // Get the table's bounding rectangle
            const cellRect = cell.getBoundingClientRect(); // Get the cell's bounding rectangle
            const tableTop = tableRect.top + scrollPosition; // Calculate the table's top position relative to the document
            const tableBottom = tableRect.bottom + scrollPosition; // Calculate the table's bottom position relative to the document

            // Check if the top of the table is within the offset from the top of the viewport
            if (scrollPosition >= tableTop - offset && scrollPosition < tableBottom - cellRect.height - offset) {
                cell.classList.add('col-cell-fix'); // Add the fixed position class to the hero cell
                cell.style.transform = `translateY(${scrollPosition - tableTop + headerHeight - 350}px)`; // Adjust the cell's position
            } else {
                cell.classList.remove('col-cell-fix'); // Remove the fixed position class if conditions are not met
                cell.style.transform = 'translateY(0)'; // Reset the cell's position
            }

            // Ensure the fixed cell does not move beyond the last row of the table
            if (scrollPosition >= tableBottom - cellRect.height - offset + headerHeight + 1000) {
                cell.classList.remove('col-cell-fix'); // Remove the fixed position class
                cell.style.transform = `translateY(${tableBottom - cellRect.height - tableTop}px)`; // Set the cell's position to the bottom of the table
            }
        });
    }

    // Add event listeners for scroll and resize events to update hero cell positions
    window.addEventListener('scroll', checkHeroCellPosition);
    window.addEventListener('resize', checkHeroCellPosition);

    // Initial check on page load
    checkHeroCellPosition();
});

// END - fixes the position of hero cells in a comparison table
//////////////////////////////////////////////////////////////////////////


//////////////////////////////////////////////////////////////////////////
// START - Styles for Select All/Deselect All" toggle buttons in Gravity Forms.

/**
 * This script manages the "Select All/Deselect All" toggle buttons in Gravity Forms.
 * It handles dynamic form loading and ensures proper button state management.
 */

// Function to handle the button state change
function handleToggleButton(button) {
    const selectText = button.getAttribute('data-label-select');
    const deselectText = button.getAttribute('data-label-deselect');
    
    // Check the current state of the checkboxes
    const checkboxes = button.closest('.gfield').querySelectorAll('input[type="checkbox"]');
    const isAllChecked = Array.from(checkboxes).every(checkbox => checkbox.checked);

    if (isAllChecked) {
        button.textContent = deselectText;
        button.classList.add('gfield_choice_all_toggle--checked');
    } else {
        button.textContent = selectText;
        button.classList.remove('gfield_choice_all_toggle--checked');
    }
}

// Function to initialize toggle buttons
function initializeToggleButtons() {
    const buttons = document.querySelectorAll('.gfield_choice_all_toggle');
    buttons.forEach(button => {
        button.removeEventListener('click', handleToggleButtonClick);
        button.addEventListener('click', handleToggleButtonClick);
        // Initial state setup
        handleToggleButton(button);
    });
}

// Function to handle button click
function handleToggleButtonClick() {
    // Allow the default Gravity Forms toggle action to complete
    setTimeout(() => handleToggleButton(this), 10);
}

// MutationObserver to detect when new form steps are added
const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        if (mutation.type === 'childList') {
            initializeToggleButtons();
        }
    });
});

// Configuration for the observer
const config = { childList: true, subtree: true };

//////////////////////////////////////////////////////////////////////////
// Start observing the form container when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
    const formContainer = document.querySelector('.gform_wrapper');
    if (formContainer) {
        observer.observe(formContainer, config);
    }
    
    // Initialize buttons that are already in the DOM
    initializeToggleButtons();
});

// END - Styles for Select All/Deselect All" toggle buttons in Gravity Forms.
//////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////
// Start Scroll to top when clicking vertical tab navigation buttons
(function() {
    'use strict';

    document.addEventListener('DOMContentLoaded', function() {
        const nav = document.getElementById('vertical-tabs-nav');

        if (nav) {
            nav.addEventListener('click', function(event) {
                // Check if clicked element is a direct child button of vertical-tabs-nav
                if (event.target.matches('#vertical-tabs-nav > button')) {
                    window.scrollTo({
                        top: 0
                    });
                }
            });
        }
    });
})();
// END Scroll to top when clicking vertical tab navigation buttons
//////////////////////////////////////////////////////////////////////////

/**
 * Load the comparison table JS
 */
function load_comparison_table() {

    ////////////////////////////////////////////////
    // START - comparison table turn cols into slider
    var comparisonTableSlider = jQuery('.table-col-slider');
    // slick slider settings
    var comparisonTableSliderSettings = {
        mobileFirst: true,
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-arrow slick-prev"><span class="visually-hidden">Previous</span></button>',
        nextArrow: '<button class="slick-arrow slick-next"><span class="visually-hidden">Next</span></button>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]

    }

    if (comparisonTableSlider.length > 0) {
        // set slides to same height
        comparisonTableSlider.on('setPosition', function () {
            jQuery(this).find('.table-col-slider__item').height('auto');
            var slickTrack = jQuery(this).find('.slick-track');
            var slickTrackHeight = jQuery(slickTrack).height();
            jQuery(this).find('.table-col-slider__item').css('height', slickTrackHeight + 'px');
        });

        // work out resize function to reinit or destroy slider on load and window resize
        jQuery(window).on('load resize', function() {        
            // init slider if not already initialised
            comparisonTableSlider.not('.slick-initialized').slick(comparisonTableSliderSettings);
        });

        comparisonTableSlider.not('.slick-initialized').slick(comparisonTableSliderSettings);
    }
    // END - comparison table turn cols into slider
    ///////////////////////////////////////////////

    ////////////////////////////////////////////////
    // START - comparison table match cell heights
    window.addEventListener("load", updateCompTableCellHeights);
    window.addEventListener("resize", updateCompTableCellHeights);

    function updateCompTableCellHeights() {
        const compTables = document.querySelectorAll('.comparison-table');

        compTables.forEach(table => {
            const compTableCols = table.querySelectorAll('.comparison-table__col');
            if (compTableCols.length === 0) return;

            // Determine the maximum number of child elements within this table
            const compTableColsMaxChildren = Math.max(...Array.from(compTableCols).map(col => col.children.length));

            // Loop through each nth-child index
            for (let i = 1; i <= compTableColsMaxChildren; i++) {
                const compTableCells = table.querySelectorAll(`.comparison-table__col > div:nth-child(${i})`);
                let maxHeight = 0;

                // Reset heights to auto to calculate the natural heights
                compTableCells.forEach(element => {
                    element.style.height = 'auto';
                });

                // Find the maximum height for this nth-child within this table
                compTableCells.forEach(element => {
                    const height = element.offsetHeight;
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                });

                // Set all elements to the maximum height for this nth-child within this table
                compTableCells.forEach(element => {
                    element.style.height = `${maxHeight}px`;
                });
            }
        });
    }
	// Initial check on load
    updateCompTableCellHeights();
    // END - comparison table match cell heights
    //////////////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////////////////////
    // START - scroll behaviour to add and remove classes on comparison table
	const siteHeader = document.querySelector('.header');
	const comparisonTables = document.querySelectorAll('.comparison-table');
	const siteHeaderHeight = siteHeader ? siteHeader.offsetHeight : 0;

	// Function to check visibility of elements and update classes
	function checkTableVisibility() {
		comparisonTables.forEach(table => {
			const rect = table.getBoundingClientRect();
			const tableTop = rect.top;
			const tableBottom = rect.bottom;

			// Check if the bottom of the table is above the bottom of the viewport
			const isAboveViewportBottom = tableBottom <= window.innerHeight;

			// Add 'in-view' class if the top of the table is within the viewport and remove otherwise
			if (tableTop < window.innerHeight && !isAboveViewportBottom) {
				table.classList.add('in-view');
			} else {
				table.classList.remove('in-view');
			}

			// Add 'fix-first-cell' class if the top of the table is near the header and remove otherwise
			if (tableTop <= siteHeaderHeight && tableBottom >= siteHeaderHeight) {
				table.classList.add('fix-first-cell');
			} else {
				table.classList.remove('fix-first-cell');
			}
		});
	}

	// Event listener for scroll and resize to update visibility classes
	window.addEventListener('scroll', checkTableVisibility);
	window.addEventListener('resize', checkTableVisibility);

	// Initial check on load
	checkTableVisibility();
    // END - scroll behaviour to add and remove classes on comparison table
    //////////////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////////////////////
    // START - fixes the position of hero cells in a comparison table
    const heroCells = document.querySelectorAll('.product-col__cell--hero'); // Select all hero cells in the comparison table
    const header = document.querySelector('.header'); // Select the header element
    const offset = -100; // Offset from top of viewport in pixels

    function checkHeroCellPosition() {
        const scrollPosition = window.scrollY; // Get the current scroll position
        const headerHeight = header ? header.offsetHeight : 0; // Get the header height or set to 0 if header is not found

        heroCells.forEach(cell => {
            const table = cell.closest('.comparison-table'); // Find the closest comparison table ancestor
            const tableRect = table.getBoundingClientRect(); // Get the table's bounding rectangle
            const cellRect = cell.getBoundingClientRect(); // Get the cell's bounding rectangle
            const tableTop = tableRect.top + scrollPosition; // Calculate the table's top position relative to the document
            const tableBottom = tableRect.bottom + scrollPosition; // Calculate the table's bottom position relative to the document

            // Check if the top of the table is within the offset from the top of the viewport
            if (scrollPosition >= tableTop - offset && scrollPosition < tableBottom - cellRect.height - offset) {
                cell.classList.add('col-cell-fix'); // Add the fixed position class to the hero cell
                cell.style.transform = `translateY(${scrollPosition - tableTop + headerHeight - 350}px)`; // Adjust the cell's position
            } else {
                cell.classList.remove('col-cell-fix'); // Remove the fixed position class if conditions are not met
                cell.style.transform = 'translateY(0)'; // Reset the cell's position
            }

            // Ensure the fixed cell does not move beyond the last row of the table
            if (scrollPosition >= tableBottom - cellRect.height - offset + headerHeight + 1000) {
                cell.classList.remove('col-cell-fix'); // Remove the fixed position class
                cell.style.transform = `translateY(${tableBottom - cellRect.height - tableTop}px)`; // Set the cell's position to the bottom of the table
            }
        });
    }

    // Add event listeners for scroll and resize events to update hero cell positions
    window.addEventListener('scroll', checkHeroCellPosition);
    window.addEventListener('resize', checkHeroCellPosition);

    // Initial check on page load
    checkHeroCellPosition();

    // END - fixes the position of hero cells in a comparison table
    //////////////////////////////////////////////////////////////////////////

}